import { Component, input, output } from '@angular/core';

import { CartService } from '@core/services/cart/cart.service';
import { ComoService } from '@core/services/como/como.service';

import { rxResource, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DoodProductModel } from '@core/models/product.model';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ComoProductsSelectionStep } from '@shared/modals/como/como-products-selection-modal/como-products-selection-step-model';
import { CART_ACTIONS } from '@store/cart';
import { PRODUCT_STORE_COMPONENT_ACTIONS } from '@store/product';

@Component({
  selector: 'app-como-products-selection-step',
  templateUrl: './como-products-selection-step.component.html',
  standalone: false,
})
export class ComoProductsSelectionStepComponent {
  readonly step = input.required<ComoProductsSelectionStep>();
  readonly goToNextStep = output<void>();

  readonly productsQuery = rxResource({
    params: this.step,
    stream: ({ params }) =>
      this.comoService.allowedProducts$(params.ids, this.cartService.getShopId()),
  });

  constructor(
    private readonly comoService: ComoService,
    private readonly cartService: CartService,
    private readonly store: Store,
    private readonly actions$: Actions,
  ) {
    this.actions$
      .pipe(ofType(CART_ACTIONS.updateProductInCart))
      .pipe(takeUntilDestroyed())
      .subscribe(({ action }) => {
        if (action === 'add' || action === 'increase') {
          this.goToNextStep.emit();
          return;
        }
      });
  }

  onNavigateTo(product: DoodProductModel): void {
    const shopId = product.shop_id ?? this.cartService.getShopId() ?? '';
    if (!shopId) {
      return;
    }

    this.store.dispatch(
      PRODUCT_STORE_COMPONENT_ACTIONS.selectProduct({
        productId: product.id,
        productShopId: shopId,
        productOrigin: {
          channel: 'loyalty',
          reference: 'como',
        },
      }),
    );
  }
}
